export const handleError = (commit, e) => {
    console.error(e);
    commit('progressbar', false);
    commit('snackbar', {
        text: e.message,
        color: 'error',
    });
};
